module.exports = __webpack_public_path__ + "img/willbaldlygo-8108.c7b55f0d.jpeg";